import type { SeoMetaData } from "@/lib/seo-meta";

export function buildPublicListPreviewData(
  list: { description: string | null },
  releaseIds: readonly string[],
  fallbackDescription: string,
): Pick<SeoMetaData, "description" | "imageUrl"> {
  return {
    description: list.description || fallbackDescription,
    imageUrl: releaseIds.slice(0, 1).map((releaseId) => `/cdn/release/${releaseId}/0`)[0],
  };
}
